import { render, staticRenderFns } from "./article-card-sm.vue?vue&type=template&id=89090470&scoped=true&"
import script from "./article-card-sm.vue?vue&type=script&lang=js&"
export * from "./article-card-sm.vue?vue&type=script&lang=js&"
import style0 from "./article-card-sm.vue?vue&type=style&index=0&id=89090470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89090470",
  null
  
)

export default component.exports